export enum QueryParameter {
  Search = 'search',
  Status = 'status',
  From = 'from',
  To = 'to',
  Enabled = 'enabled',
  Categories = 'categories',
  ParentCategories = 'parent-categories',
  Suppliers = 'suppliers',
  Departments = 'departments',
  Accounts = 'accounts',
  SupplierProductCode = 'supplier-product-code',
  PurchaserProductCode = 'purchaser-product-code',
  PPlusProductCode = 'p-plus-product-code',
  MatchedInvoice = 'matched-invoice',
  CompletedReceivingNote = 'completed-receiving-note',
  PeriodYear = 'period-year',
  PeriodMonth = 'period-month',
  BestBuy = 'best-buy',
  StockLocations = 'stock-locations',
  OriginStockLocation = 'origin-stock-location',
  DestinationStockLocation = 'destination-stock-location',
  CountStatus = 'count-status',
  HideZero = 'hide-zero',
  SelfManaged = 'self-managed',
  HasQuotes = 'has-quotes',
  MasterProduct = 'master-product',
  OpenHierarchy = 'open-hierarchy',
  Image = 'image',
  Catalogued = 'catalogued',
  Matched = 'matched',
  CountedItems = 'counted-items',
  RequisitionType = 'requisition-type',
  Destination = 'destination',
  Owner = 'owner',
  OrganisationUnit = 'organisation-unit',
  Preferred = 'preferred',
  Verified = 'verified',
  LegalEntity = 'legal-entity',
  Id = 'id',
  TradeRelationshipId = 'trade-relationship-id',
  ApSystemId = 'ap-system-id',
  PurchaserId = 'purchaser-id',
  SupplierId = 'supplier-id',
  OwnerId = 'owner-id',
  OwnerName = 'owner-name',
  Barcode = 'barcode',
  TransferTypes = 'transfer-types',
  CatalogFilter = 'catalog-filter',
  AlreadyReceived = 'already-received',
  PPlusCode = 'p-plus-code',
  OrganisationId = 'organisation-id',
  InvoiceNumber = 'invoice-number',
  CreditNoteNumber = 'credit-note-number',
  CatalogId = 'catalog-id',
  TradeRelationshipPurchaserId = 'tr-purchaser-id',
  TradeRelationshipSupplierId = 'tr-supplier-id',
  CatalogOwnerId = 'catalog-owner-id',
  CatalogSupplierId = 'catalog-supplier-id',
  SMCatalog = 'self-managed-catalog',
  Contracted = 'contracted',
  Common = 'common',
  DocumentType = 'document-type',
  WorkflowType = 'workflow-type',
  CustomCodeEnabled = 'custom-code-enabled',
  SubjectLine = 'subject-line',
  MarkedAs = 'marked-as',
  BusinessNumber = 'business-number',
  DocumentNumber = 'document-number',
  UserId = 'user-id',
  Email = 'email',
  Reference = 'reference',
  PaymentStatus = 'payment-status',
  AccountType = 'account-type',
  ExternalId = 'external-id',
  GhostLines = 'ghost-lines',
  IsRecipe = 'is-recipe',
  Type = 'type',
  UnitSize = 'unit-size',
  UnitMeasure = 'unit-measure',
  SellQuantity = 'sell-quantity',
  SellPackName = 'sell-pack-name',
  ShowErrors = 'show-errors',
  CreatedDocument = 'created-document',
  SupplierOrganisationId = 'supplier-organisation-id',
  PurchaserOrganisationId = 'purchaser-organisation-id',
  HasPurchaseOrder = 'has-purchase-order',
  HasReceivingNotes = 'has-receiving-notes',
  HasOperationalApproval = 'has-operational-approval',
  ProductId = 'product-id',
  BuyListId = 'buy-list-id',
  StructurallySimilar = 'structurally-similar',
  ToEmail = 'to-email',
  CcEmail = 'cc-email',
  Connected = 'connected',
  FromEmail = 'from-email',
  PaperlessMatchString = 'paperless-match-string',
  RequisitionStatus = 'requisition-status',
  SupplierNumber = 'supplier-number',
  ProcessedAs = 'processed-as',
  InvoiceAge = 'invoice-age',
  HasSupplier = 'has-supplier',
  ReportCategory = 'report-category',
  ReportType = 'report-type',
  ScanningTaskId = 'scanning-task-id',
  ScanningTaskNumber = 'scanning-task-number',
  ProductTags = 'productTags',
  OrganisationTags = 'organisation-tags',
  MenuSections = 'menu-sections',
  PurchaserName = 'purchaser-name',
  StatementAvailability = 'statement-availability',
}
